var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("sys-register-base", {
    attrs: {
      loading: _vm.loading,
      model: _vm.model,
      title: _vm.title,
      icon: _vm.icon,
      show: _vm.dialog,
      maxWidth: "70%",
    },
    on: {
      onSave: _vm.save,
      "update:model": function ($event) {
        _vm.model = $event
      },
      "update:show": function ($event) {
        _vm.dialog = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "form",
        fn: function () {
          return [
            _c(
              "v-container",
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("sys-select-course-level", {
                          attrs: {
                            model: _vm.model.course_level_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.course_level_id,
                            label: "Nível de Curso*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "course_level_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("sys-select-campus", {
                          attrs: {
                            model: _vm.model.campus_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.campus_id,
                            label: "Campus*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(_vm.model, "campus_id", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("sys-select-value-type", {
                          attrs: {
                            model: _vm.model.value_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.value_type_id,
                            label: "Tipo de Valor*",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "value_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "3" } },
                      [
                        _c("sys-select-budget-type", {
                          attrs: {
                            model: _vm.model.budget_type_id,
                            error: _vm.errors.length > 0,
                            errors: _vm.errors.budget_type_id,
                            label: "Tipo de Orçamento*",
                            showAdd: "",
                            dense: "",
                          },
                          on: {
                            "update:model": function ($event) {
                              return _vm.$set(
                                _vm.model,
                                "budget_type_id",
                                $event
                              )
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            error: !!_vm.errors.year,
                            "error-messages": _vm.errors.year,
                            label: "Ano*",
                            dense: "",
                            disabled: "",
                          },
                          model: {
                            value: _vm.model.year,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "year", $$v)
                            },
                            expression: "model.year",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  [
                    _vm._l(
                      _vm.months.filter((m) => m.show),
                      function (month, i) {
                        return _c(
                          "v-col",
                          { key: i, attrs: { cols: "12", sm: "2" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                dense: "",
                                error: !!_vm.errors[month["month"]],
                                "error-messages": _vm.errors[month["month"]],
                                outlined: "",
                                label: month["label"],
                              },
                              model: {
                                value: _vm.model[month["month"]],
                                callback: function ($$v) {
                                  _vm.$set(_vm.model, month["month"], $$v)
                                },
                                expression: "model[month['month']]",
                              },
                            }),
                          ],
                          1
                        )
                      }
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("s-text-field", {
                          attrs: {
                            code: "",
                            "error-messages": _vm.errors.code,
                            label: "Código",
                          },
                          model: {
                            value: _vm.model.code,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "code", $$v)
                            },
                            expression: "model.code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "2" } },
                      [
                        _c("v-switch", {
                          attrs: { inset: "", label: "Digital" },
                          model: {
                            value: _vm.model.digital,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "digital", $$v)
                            },
                            expression: "model.digital",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  2
                ),
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", sm: "12" } },
                      [
                        _c("v-textarea", {
                          attrs: {
                            error: !!_vm.errors.description,
                            "error-messages": _vm.errors.description,
                            label: "Descrição",
                            counter: 255,
                            rules: [
                              (v) =>
                                !v ||
                                v.length <= 255 ||
                                "Máximo de 255 caracteres atingido",
                            ],
                            outlined: "",
                          },
                          model: {
                            value: _vm.model.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "description", $$v)
                            },
                            expression: "model.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("emc-alert-snackbar", {
              attrs: {
                show: !!_vm.message.length,
                message: _vm.message,
                color: _vm.error ? "error" : "success",
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }